import {
  BASIC_ACCOUNT_STATUS,
  ICorpByRole,
} from 'src/components/AuthProvider/AuthProvider';

export const DEFAULT_STEP_NUMBER = 1;

export function getFirstActiveBasicCorpId(
  basicCorps: ICorpByRole[]
): string | undefined {
  return basicCorps.find(
    ({ account_status }) => account_status === BASIC_ACCOUNT_STATUS.ACTIVE
  )?.owner_id;
}

interface GetSelfServiceHomeRedirectPathParams {
  urlStepNumber: number;
  basicCorps: ICorpByRole[];
}

export function getSelfServiceHomeRedirectPath({
  urlStepNumber,
  basicCorps,
}: GetSelfServiceHomeRedirectPathParams): string | null {
  if (!(urlStepNumber > DEFAULT_STEP_NUMBER)) {
    return null;
  }

  const corpId = getFirstActiveBasicCorpId(basicCorps);

  if (!corpId) {
    return null;
  }

  return `/corporate/management/${corpId}/home`;
}
